import { Component, Input } from '@angular/core';

// Multimedia help modal.
@Component({
  selector: 'help-modal',
  templateUrl: './help-modal.component.html',
})
export class HelpModalComponent {
  @Input() webAppName: string = '';
  @Input() helpData: any;
}
